<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Dicas de Exposição</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="exposition">Dicas de Exposição</label>
                                    <select name="exposition[]" id="exposition" v-model="ordered" size="8" multiple>
                                        <option :value="index" v-for="(exposition, index) in exposition">
                                            {{ exposition.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setExpositions">Ordenar Dicas de Exposição <i class="fa fa-shopping-bag"></i></button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li v-for='(exposition,index) in selected' :key="exposition.id" class="list-group-item clearfix draggable">
                                        <i class="mdi mdi-drag pull-left" ></i>
                                        <i class="pull-left fa fa-2x fa-arrows-v align-middle"></i>
                                        <span class="pull-left stages" :id="'stage' + exposition.id">{{ index + 1 }}. {{ exposition.name }} </span>
                                        <button class="btn btn-danger pull-right" @click="remove(exposition, index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back"><i class="fa fa-arrow-left"></i> Voltar</button>
                                <button class="btn btn-success" @click="save" style="margin-left:3px;">Salvar Ordenação <i class="fa fa-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { postReorder } from "../../utils";

    export default{
        data: function(){
            return {
                exposition: [],
                selected: [],
                ordered: [],
                order: false
            }
        },
        components: {
            draggable
        },
        methods: {
            getExpositionsArray: function(data){
                let array = [];
                $.each(data, function(index, value){
                    if(value.sort_by){
                        array.push(index);
                    }
                });
                return array;
            },
            getExpositions: function(){
                let self = this;
                let api  = self.$store.state.api + 'exposition?paginated=false';
                let exposition = $('#exposition');

                self.$http.get(api)
                    .then((response) => {
                        self.exposition = response.data.data;
                        self.ordered  = self.getExpositionsArray(self.exposition);
                    })
                    .then(() => {
                        exposition.bootstrapDualListbox();
                        exposition.ready(function () {
                            exposition.bootstrapDualListbox('refresh', true);
                        });
                    })
                    .catch((error) => {
                        self.$message(null, 'Ocorreu um erro ao buscar os Promotional Materials', 'error');
                    });
            },
            setExpositions: function(){
                const self   = this;
                let exposition = self.selected;

                $('#exposition').find(':selected').each(function(){
                    exposition.push(self.exposition[$(this).val()]);
                });

                self.selected = exposition;
                self.order = true;
            },
            save: function(){
                const self = this;

                postReorder(self, self.selected, "sort/exposition", self.getExpositionsArray);
            },
            remove: function(exposition, index){
                const self = this;
                const api  = self.$store.state.api + 'exposition/' + exposition.id;

                let array  = [];
                $.each(self.selected, function(key, value){
                    if(index !== key){
                        array.push(value);
                    }
                });

                self.$http.put(api, {
                    sort_by: null
                })
                    .then((response) => {
                        this.selected = array;
                    });
            },
            back: function(){
                window.location.reload();
            }
        },
        mounted: function(){
            this.getExpositions();
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ExpositionOrder/Index.vue